var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"twitch"},[_c('div',{ref:_vm.refId,staticClass:"twitch-video"}),_vm._v(" "),_c('div',{staticClass:"twitch-chat"},[_c('iframe',{attrs:{"id":_vm.channel,"frameborder":"0","scrolling":"no","src":`https://www.twitch.tv/embed/${_vm.channel}/chat?${_vm.parentURLString}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }